import { createApi } from '@reduxjs/toolkit/query/react'
import { UserRoleEnum } from 'api/roles'
import { IMenu, MenuResponse, MenuTypeEnum } from 'shared/models/Menu'
import axiosBaseQuery from 'shared/utils/axiosBaseQuery'
import {
  mapMenu,
  mapMenuAuditor,
  mapMenuJanitor,
} from 'shared/utils/menu/menuMapper'
import { RootState } from '../store'
import { getClientWithRoleAndClientId } from '../user/selectors'

const headers = {
  'x-api-version': '2.0',
}

const menuApi = createApi({
  reducerPath: 'menu',
  baseQuery: axiosBaseQuery({
    baseUrl: '/menu/menu/portalv2/client',
  }),
  endpoints: (build) => ({
    getMenu: build.query<IMenu[], string | null>({
      async queryFn(clientId, { getState }, _extraOptions, query) {
        const store = getState() as RootState
        const checkForRole = getClientWithRoleAndClientId(store)

        const menus: IMenu[] = []

        if (!clientId) return { data: menus }

        // fetch auditor menu
        if (checkForRole(UserRoleEnum.auditor, clientId)) {
          const auditor = await query({
            url: `/${clientId}?menuId=${MenuTypeEnum.auditor}`,
            method: 'GET',
            headers,
          })

          if (!auditor.error) {
            const auditorMenu = mapMenuAuditor(
              (auditor.data as MenuResponse).menuGroups
            )
            menus.push(...auditorMenu)
          }
        }

        if (checkForRole(UserRoleEnum.caretaker, clientId)) {
          // fetch janitor menu
          const janitor = await query({
            url: `/${clientId}?menuId=${MenuTypeEnum.janitor}`,
            method: 'GET',
            headers,
          })

          if (!janitor.error) {
            const janitorMenu = mapMenuJanitor(
              (janitor.data as MenuResponse).menuGroups
            )
            menus.push(...janitorMenu)
          }
        }

        // get menu base menu
        const result = await query({
          url: `/${clientId}?menuId=${MenuTypeEnum.board}`,
          method: 'GET',
          headers,
        })

        if (!result.error) {
          const baseMenu = mapMenu((result.data as MenuResponse).menuGroups)
          menus.push(...baseMenu)
        }

        return { data: menus as IMenu[] }
      },
    }),
  }),
})

export default menuApi
